// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3aapz","location":"Header_location__M7BR8"};